
module dg.actions {
    import ListQuery = dg.domain.queries.ListQuery;
    import IQueryAction = dg.domain.queries.IQueryAction;


    export interface IQueryOptions {
        exportOptions?: dg.navigation.IExportsListOptions;
        actionOptions?: dg.navigation.IActionOptions;
        queryParameters?: any;
        isModal?: boolean;
        hideActions?: boolean;
        childDisplayers?: {
            [id: string]: ICompositeDisplayerOptions;
        }
    }

    export interface IQueryInvokerOptions extends IQueryOptions {
        resultDisplayers?: ICompositeDisplayerOptions[];
    }

    export interface ICompositeDisplayerOptions {
        type?: string;
        //id?: string;
        displayValue?: string;
        templateUrl?: string;
    }

    export interface IQueryStateResolve extends angular.ui.IViewStateResolve {
        query?: (...args: any[]) => ListQuery<dg.domain.IDomainObject> | ng.IPromise<ListQuery<dg.domain.IDomainObject>>;
        link?(...args: any[]): dg.restfulApi.Link | ng.IPromise<dg.restfulApi.Link>;
        options?: (...args: any[]) => IQueryInvokerOptions | ng.IPromise<IQueryInvokerOptions>;
    }

    export interface IModalListQueryStateResolve extends angular.ui.IViewStateResolve {
        modalTitle?(...args: any[]): string | ng.IPromise<string>;
        link?(...args: any[]): dg.restfulApi.Link | ng.IPromise<dg.restfulApi.Link>;
        options?: (...args: any[]) => IQueryInvokerOptions | ng.IPromise<IQueryInvokerOptions>;
    }

    //interface IListQueryBindings {
    //    query: ListQuery<dg.domain.IDomainObject>;
    //    options: IListQueryOptions;
    //}

    interface IQueryInvoker {
        query: IQueryAction;
        options: IQueryInvokerOptions;
    }

    class QueryInvoker implements IQueryInvoker {

        public options: IQueryInvokerOptions;
        public compositeDisplayer: ICompositeDisplayerOptions;
        public query: IQueryAction;
        public queryParameters: any;
        public queryResult: any;
        public links: any;
        public queryManipulator: dg.actions.ServerQueryManipulator;
        public loading: any;
        public stateName: string;
        public properties: dg.restfulApi.DomainObjectPropertiesMetadata;
        public isFilteringAllowed: boolean;
        public exclude: Array<string> = ['pageNumber', 'pageSize', 'pattern'];
        public viewStyle = { height: '400px' };

        public constructor(
            protected actionService: dg.actions.ActionService,
            private $scope: ng.IScope,
            private $q: ng.IQService,
            private $filter: dgUtils.IFilterService,
            private commandExecutedChannelService: dg.actions.CommandExecutedChannelService,
            private $location: ng.ILocationService,
            private $state: ng.ui.IStateService,
            private $window: ng.IWindowService
        ) {
        }

        private destroyCommandExecutedHnadler: () => void;


        $onInit = () => {
            this.queryManipulator = new ServerQueryManipulator(this.$scope, this.$q, this.query, this.actionService);
            if (this.query.dgMeta.autoInvoke && this.canAutoInvoke()) {
                this.queryManipulator.executeQuery();
            }

            angular.element(document).ready(() => {
                this.recalculateBodyHeight();

                angular.element(this.$window).on('resize', this.recalculateBodyHeight);
            });

            this.stateName = this.$state.current.name;
            this.loading = {};
            this.loading.loaded = false;
            this.addQueryParamsToUrl(this.query);
            this.queryManipulator.onStartExecutingQuery(this.startExecuteQuery);
            this.queryManipulator.onResultChanged(this.resultChangeHandler);
            this.destroyCommandExecutedHnadler = this.commandExecutedChannelService.onCommandExecuted(this.$scope, c => {
                this.queryManipulator.executeQuery();
            });

            this.properties = this.query.dgMeta.properties;

            this.isFilteringAllowed = Object.keys(this.properties).filter((paramName) => {
                return this.exclude.indexOf(paramName) == -1;
            }).length > 0;
        };

        $onChanges(changes) {
            if (changes.options.currentValue && changes.options.currentValue.compositeDisplayers /*&& changes.options.currentValue.compositeDisplayers[0] && changes.options.currentValue.compositeDisplayers[0].templateUrl*/) {

                this.compositeDisplayer = this.getCompositeDisplayer(changes.options.currentValue.compositeDisplayers);
            }
            else {

                //Set default list composite displayer if nothing is provided
                //this.compositeDisplayer = dg.lists.ListOptionsService.getGridOptions();
            }
        }

        private getCompositeDisplayer(compositeDisplayers, compositeDisplayerType?: string) {
            if (compositeDisplayers.length > 0) {
                if (compositeDisplayers.length == 1 || compositeDisplayerType == null) {
                    return compositeDisplayers[0];
                }
                else {
                    compositeDisplayers.forEach(d => {
                        return d.type == compositeDisplayerType;
                    })
                }
            }
        }

        private recalculateBodyHeight = () => {
            this.viewStyle.height = 5 + dgUtils.UiService.recalculateViewHeight(this.$window.innerHeight) + 'px';
        }

        $onDestroy() {
            this.destroyCommandExecutedHnadler();
        }

        protected dismiss() {
            let parentScope: any = this.$scope.$parent;
            if (angular.isFunction(parentScope.$dismiss)) {
                parentScope.$dismiss();
            }
        }

        private addQueryParamsToUrl(query) {
            this.$location.search(this.actionService.getQueryParams(query));
        } 

        protected startExecuteQuery = (query) => {
            this.addQueryParamsToUrl(query);
        }

        protected resultChangeHandler = () => {
            this.queryResult = this.queryManipulator.result;
            this.links = this.queryResult.dgMeta.links;
            this.loading.loaded = true;
        }

        private canAutoInvoke = () => {
            const hasInvalidProp = Object.values(this.query.dgMeta.properties).find((prop) => {
                const anyProp = (prop as any);
                const isRequired = anyProp.extensions && anyProp.extensions.validation && anyProp.extensions.validation.rules && !!anyProp.extensions.validation.rules.find(rule => rule.code === 'NotEmpty');
                return isRequired && !this.query[anyProp.id];
            })
            return !hasInvalidProp;
        }

    }

    angular.module('dg.actions').component('queryInvoker', {
        bindings: {
            options: '<',
            query: '<', 
            //viewCssClass: '@'
        },
        controller: QueryInvoker,
        templateUrl: '/digmo/src/actions/query-invoker.html'
    });
}